import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import { detectIconById } from '../common/enum';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS_PLAYER = {
    GET_PLAYER_CONDITION_BATTER_SUCCESS: 'GET_PLAYER_CONDITION_BATTER_SUCCESS',
    GET_PLAYER_CONDITION_BATTER_ERROR: 'GET_PLAYER_CONDITION_BATTER_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getPlayerConditionBatter = (player_id, date_from, date_to) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/players/${player_id}/results/categories/types/batter?from=${date_from}&to=${date_to}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_CONDITION_BATTER_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_CONDITION_BATTER_ERROR, err));
            });
    };
};

const convertPlayerConditionBatter = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            let head = {text: value.id}
            if (value.opponent_team_name) {
                head = { text: '', img: detectIconById(value.opponent_team_id)}
            } if (value.month) {
                head = { text: value.month + "月"}
            }
            return {
                item: [
                    head,
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.g },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.r },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                    { text: value.sb },
                ]
            }
        });
        return arr;
    }
}

const convertPlayerConditionBatterRightLeft = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.opponent_name },
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                ]
            }
        });
        return arr;
    }
}


const convertPlayerConditionBatterCount = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.count_name ? value.count_name : value.runners_on_name ? value.runners_on_name : value.stadium_name },
                    { text: ('avg' in value) ? numeralFormat(value.avg, 3) : null },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                ]
            }
        });
        return arr;
    }
}


const convertPlayerConditionBatterStadium = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.stadium_name },
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.g },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                    { text: value.sb },
                ]
            }
        });
        return arr;
    }
}

const convertPlayerConditionBatterCommon = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.name },
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS_PLAYER,
    getPlayerConditionBatter,
    convertPlayerConditionBatter,
    convertPlayerConditionBatterRightLeft,
    convertPlayerConditionBatterCount,
    convertPlayerConditionBatterStadium,
    convertPlayerConditionBatterCommon
};